import {Axios} from '../../index'
import {PeriodType} from '../../../global'
import {isAxiosError} from './handleAxiosError'
import {AxiosRequestConfig} from 'axios'

interface GetInterface<T> {
    endpoint: string
    period?: PeriodType
    sortKey?: string
    sortOrder?: string
    extraParams?: Record<string, string>
    signal?: AbortSignal // Adding the signal for cancellation
}

export const Get = async <T>({
                                 endpoint,
                                 period,
                                 sortKey,
                                 sortOrder,
                                 extraParams,
                                 signal,
                             }: GetInterface<T>): Promise<T> => {

    const start = period?.start
    const end = period?.end

    try {

        const params = new URLSearchParams({
            ...(period && {start, end}),
            ...(sortKey && {sortf: sortKey}),
            ...(sortOrder && {sorts: sortOrder}),
            ...(extraParams && extraParams),

        }).toString()

        const config = {
            signal,
        } as AxiosRequestConfig

        const response = await Axios.get<T>(`${endpoint}?${params}`, config)

        return response.data
    } catch (error) {
        if (isAxiosError(error)) {
            const data = error.response?.data
            if (data.status === '401') {
                throw new Error('Unauthorized')
            }
        }
        // console.error('Error fetching data:', error)
        throw error
    }
}